import { render, staticRenderFns } from "./ReSearchObjSmall.vue?vue&type=template&id=84908d3a&scoped=true"
import script from "./ReSearchObjSmall.vue?vue&type=script&lang=js"
export * from "./ReSearchObjSmall.vue?vue&type=script&lang=js"
import style0 from "./ReSearchObjSmall.vue?vue&type=style&index=0&id=84908d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84908d3a",
  null
  
)

export default component.exports